import { Link } from 'react-router-dom';

export type AuthLinkButtonProps = {
  linkTo: string;
  text: string;
};

export const AuthLinkButton = ({ linkTo, text }: AuthLinkButtonProps) => {
  return (
    <Link
      to={linkTo}
      className="border-2 border-primary px-3 h-[44px] flex justify-center items-center rounded-full"
    >
      <div className="text-primary text-md">{text}</div>
    </Link>
  );
};
